import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import { throwIfNotOk } from '../throwIfNotOk';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/course-export-tags', 'post'>;
type ResponseBody = OASOutput<O, '/api/course-export-tags', 'post'>;

type Params = {
  tagGuid: string;
  courseExportGuid: string;
  assign: boolean;
};

type Result = Params;

export const assignTagToCourseExportFactory = (apiClient: ApiClient) => {
  const assignTagToCourseExport = async (variables: Params): Promise<Result> => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/course-export-tags'].post(requestBody);
    await throwIfNotOk(response, variables.assign ? 'assign the tag' : 'remove the tag');
    const responseBody = await response.json();

    return mapResponseToResult(responseBody, variables);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      json: {
        tagGuid: input.tagGuid,
        courseExportGuid: input.courseExportGuid,
        assign: input.assign,
      },
    };
  };

  const mapResponseToResult = (_response: ResponseBody, input: Params): Result => {
    return input;
  };

  return assignTagToCourseExport;
};
